module.exports = __webpack_public_path__ + "img/card-background.880e426.png";